import { EventEmitter, Injectable, Output } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { AuthenticateService } from './authenticate.service';
import { utilidades } from 'src/utils/utilidades';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { ControlReproductor } from '../models/control-reproductor';
import { Device, DeviceInfo } from '@capacitor/device';
const ESTADO_INICIAL: Partial<ControlReproductor> = {
  cancion: 'Sin Título',
  artista: '...',
  volumenrecibido: 100
};


@Injectable({
  providedIn: 'root'
})
export class SocketWebService {
  // http://localhost:5000 http://socket.modest-payne.74-208-219-217.plesk.page/
  public colaactiva = false;
  // callback: EventEmitter<any> = new EventEmitter();
  // callbackinfo: EventEmitter<any> = new EventEmitter();
  // callbackcola: EventEmitter<any> = new EventEmitter();
  public evento$: Observable<any> = this.socket.fromEvent('evento');
  public info$: Observable<any> = this.socket.fromEvent('info');
  public cola$: Observable<any> = this.socket.fromEvent('cola');
  public conteo$: Observable<any> = this.socket.fromEvent('conteo_moviles');
    public surcusales$: Observable<any> = this.socket.fromEvent('update_desde_sucursal');

  public version = environment.version;
public deviceModel: string = '';
  public deviceManufacturer: string = '';
  public osvercion: string = '';
  
  private usuario;
  private identity;
  private token;
  private readonly connectionStatusSubject = new BehaviorSubject<boolean>(false);
  public readonly connectionStatus$ = this.connectionStatusSubject.asObservable();
 // ✅ 2. Crea un BehaviorSubject privado. Comienza con el estado inicial.
  private readonly estadoReproductorSubject = new BehaviorSubject<Partial<ControlReproductor>>(ESTADO_INICIAL);
  // ✅ 3. Expón el estado como un Observable público.
  // Tus componentes ahora escucharán este observable.
  public readonly estadoReproductor$ = this.estadoReproductorSubject.asObservable();
// --- AÑADE ESTO ---
// ✅ 1. Crea un BehaviorSubject separado para el conteo
private readonly conteoMovilesSubject = new BehaviorSubject<number>(0);
// ✅ 2. Expón el conteo como un Observable público
public readonly conteoMoviles$ = this.conteoMovilesSubject.asObservable();
// --- FIN DE LO AÑADIDO ---
  private readonly estadoReproductoresSubject = new BehaviorSubject<Partial<ControlReproductor>>(ESTADO_INICIAL);
  // ✅ 3. Expón el estado como un Observable público.
  // Tus componentes ahora escucharán este observable.
  public readonly estadoReproductores$ = this.estadoReproductoresSubject.asObservable();

  constructor(private aut: AuthenticateService, private socket: Socket) {
    // this.logConnectionStatus();
    this.token = aut.token;
     this.escucharEventosDelSocket();
     this.escucharEstadoDeConexion();
 this.connectionStatusSubject.next(this.socket.ioSocket.connected);
  
  }
private escucharEstadoDeConexion() {
    this.socket.on('connect', () => {
      console.log('EVENTO: SOCKET CONECTADO');
     if (!this.connectionStatusSubject.value) {
        this.connectionStatusSubject.next(true);
      }
this.solicitarEstadoActual();

    });

    this.socket.on('disconnect', () => {
      console.log('EVENTO: SOCKET DESCONECTADO');
      if (this.connectionStatusSubject.value) {
        this.connectionStatusSubject.next(false);
      }
      this.conteoMovilesSubject.next(0);
    });
  }
  setIdentity(usuariocliente: string) {
    this.usuario = usuariocliente;
    // this.cambio();
  }
private solicitarEstadoActual(): void {
    console.log('SocketWeb: Solicitando estado actual del reproductor...');
    // Usamos el mismo evento 'start' que tu app ya entiende
    // para que el servidor nos devuelva el estado completo.
     const datacontrol: ControlReproductor = {
      idset: '0',
      indicelist: 1,
      tiposet: 'start',
    };
    this.emitEvent(datacontrol); 
  }
// ✅ 4. Un método privado que escucha los eventos reales y actualiza el estado.
  private escucharEventosDelSocket() {
    // Unimos ambos eventos en uno solo
    this.socket.fromEvent('info').subscribe(data => {
         console.log('evento recibido en servicio socketweb', data);
      this.estadoReproductorSubject.next(data as Partial<ControlReproductor>);
    });
    this.socket.fromEvent('evento').subscribe(data => {
      console.log('evento recibido en servicio socketweb', data);
      this.estadoReproductorSubject.next(data as Partial<ControlReproductor>);
    });
     this.socket.fromEvent('conteo_moviles').subscribe(data => {
      console.log('conteo recibido en servicio socketweb', data);
      this.conteoMovilesSubject.next(Number(data));
    });
     this.socket.fromEvent('update_desde_sucursal').subscribe(data => {
      console.log('reciviendo socjet de sucursales', data);
      this.estadoReproductoresSubject.next(data as Partial<ControlReproductor>);
    });
  }
  // async listen() {
  //   await this.cambio();
  //   this.socket.on('evento', res => {
  //     this.callback.emit(res);
  //     console.log('escuchando socket ', res);
  //   });

  //   this.socket.on('info', res => {
  //     this.callbackinfo.emit(res);
  //     console.log('escuchando socket info ', res);

  //     console.log('avtiva', res.colaactiva);
  //     this.colaactiva = res.colaactiva;
  //     // localStorage.setItem('reproductor',JSON.stringify(res));
  //   });
  //   this.socket.on('cola', res => {
  //     this.callbackcola.emit(res);
  //     console.log('escuchando socket cola ', res);
  //     // localStorage.setItem('reproductor',JSON.stringify(res));+'12'
  //   });
  // }
  // async cambio() {
  //   this.socket.ioSocket.disconnect();
  //   // this.socket.ioSocket.close();
  //   this.identity = await this.aut.recuperarIdentity();
  //   const nameRoom = this.identity.usuario;
  //   const dispositivo = 'android-V2.2.8.4';
  //   //  const nameRoom = this.usuario;
  //   console.log('user socket', nameRoom);
  //   this.socket.ioSocket.io.opts.query = { nameRoom, dispositivo };
  //   this.socket.ioSocket.connect();
  // }
  emitEvent = (payload = {}) => {
    console.log('enviando soket  evento', payload);
    this.socket.emit('evento', payload);

  };

  emitEventUpdate = (payload = {}) => {
    console.log('enviando socket update', payload);
    this.socket.emit('update', payload);
  };
   emitEventMaestro= (payload = {}) => {
    
    console.log('Enviando comando remoto:', payload);
    this.socket.emit('comando_maestro', payload);
  }
  desconectar() {
    console.log('saliiendo...');
    this.socket.disconnect();

  }


   async reconnectWithNewIdentity() {
    // 1. Desconecta el socket actual que estaba en la sala por defecto
    this.socket.disconnect();
this.estadoReproductorSubject.next(ESTADO_INICIAL);
// this.estadoReproductoresSubject.next(ESTADO_INICIAL);
    // 2. Obtiene la nueva identidad del usuario
    const identity:any = await this.aut.recuperarIdentity();
    // console.log('identity para socket',identity);
      console.log('identity usuario para socket',identity.usuario);
      await this.loadDeviceInfo();
    if (!identity) {
      console.error('No se pudo obtener la identidad para reconectar el socket.');
      return;
    }
// 3. ACTUALIZA el 'query' del socket con los datos del usuario
    this.socket.ioSocket.io.opts.query = { 
      nameRoom: identity.usuario,
      device: 'movil',
      dispositivo: 'android-V'+this.version+' '+ this.deviceModel + ' '+ this.deviceManufacturer+' '+ this.osvercion, // O el valor que necesites
      grupo_negocios: identity.empresaid

    };
// 4. Conecta de nuevo. Ahora usará la configuración correcta.
    console.log(`Socket reconectando con el usuario: ${identity.usuario}`);
    this.socket.connect();

 }
  // private logConnectionStatus() {
  //   this.socket.on('connect', () => console.log('✅ Socket Conectado'));
  //   this.socket.on('disconnect', () => console.log('❌ Socket Desconectado'));
  // }

    disconnectAndReset() {
    console.log('Reseteando conexión de socket al cerrar sesión...');
    this.socket.disconnect();

    // Actualizamos la configuración para que la próxima conexión sea a la sala por defecto
    this.socket.ioSocket.io.opts.query = {
      nameRoom: 'default-room'
    };
    
    // Opcional: puedes reconectar inmediatamente a la sala por defecto,
    // o simplemente dejarlo desconectado hasta el próximo login.
    // Reconectar es útil si tienes eventos públicos en tu app.
    this.socket.connect();
     this.estadoReproductorSubject.next(ESTADO_INICIAL);
  }



  async loadDeviceInfo() {
    try {
      const info: DeviceInfo = await Device.getInfo();
      
      // 3. Accede a la propiedad 'model'
      this.deviceModel = info.model;
      this.deviceManufacturer = info.manufacturer;
      this.osvercion = info.osVersion;


      console.log('Modelo:', this.deviceModel); // Ej: "iPhone" o "Galaxy S23"
      console.log('Fabricante:', this.deviceManufacturer); // Ej: "Apple" o "Samsung"
      console.log('Plataforma:', info.platform); // "ios", "android" o "web"
      console.log('Versión OS:', info.osVersion);
      
    } catch (e) {
      console.error('Error al obtener la información del dispositivo', e);
    }
  }

  checkConnection() {
    // Si el socket está desconectado, forzamos la conexión
    if (!this.socket.ioSocket.connected) {
        console.log('Forzando reconexión...');
        this.socket.connect();
    } else {
        // A veces dice "connected" pero es mentira porque el ping falló en background.
        // Un truco es desconectar y reconectar rápido o emitir un ping manual.
        console.log('El socket reporta estar conectado.');
    }
}
}
